import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createBlock(_component_Field, null, {
    default: _withCtx(() => [
      _createVNode(_component_Label, { for: _ctx.id }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ]),
        _: 1
      }, 8, ["for"]),
      _createVNode(_component_Select, {
        options: _ctx.options,
        name: _ctx.name,
        id: _ctx.id,
        value: _ctx.value,
        onOnChange: _ctx.onChange
      }, null, 8, ["options", "name", "id", "value", "onOnChange"])
    ]),
    _: 1
  }))
}